import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L, ModuleFE_Thunderstorm, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { __stringify } from '@nu-art/ts-common';
import { Component_EditorHeader, viewMode_Edit, viewMode_View } from '@app/styles';
import { SearchableItem_FlowSheet } from '../searchable-items.js';
import './Editor_FlowSheet.scss';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_InputText, DefaultEditor_TextArea } from '@app/styles/frontend/ui-manager/ui-components';
export class Editor_FlowSheet extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = nextProps.editMode ?? (!state.editable.item._id ? true : (this.state?.editMode ?? false));
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? viewMode_Edit : viewMode_View;
    getItemActions = () => {
        return [{
                label: 'Edit Flow Sheet',
                action: async () => this.setState({ editMode: true }),
            }, {
                label: 'Delete Flow Sheet',
                action: async () => {
                    await this.state.editable.delete();
                    this.props.deselect?.();
                }
            }, {
                label: 'Export JSON',
                action: async () => {
                    const item = this.state.editable.item;
                    ModuleFE_Thunderstorm.downloadFile({
                        fileName: `Flow Sheet - ${item.label}`,
                        mimeType: 'application/json',
                        content: __stringify(item, true)
                    });
                }
            }];
    };
    getEditModeActions = () => {
        //Actions for existing item
        if (this.state.editable.item._id)
            return [{
                    label: 'Done',
                    action: async () => this.setState({ editMode: false }),
                }];
        //Actions for new item
        return [{
                label: 'Cancel',
                action: async () => {
                    return this.props.deselect();
                },
            }, {
                label: 'Save',
                action: async () => {
                    await this.state.editable.save();
                },
            }];
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: 'editor__flow-sheet', children: [!this.props.hideHeader && this.renderHeader(), this.renderBody()] });
    }
    renderHeader = () => {
        return _jsx(Component_EditorHeader, { editable: this.state.editable, searchItem: SearchableItem_FlowSheet, editMode: this.state.editMode, itemActions: this.getItemActions(), editModeActions: this.getEditModeActions() });
    };
    renderBody = () => {
        return _jsxs(LL_V_L, { className: 'editor__body', children: [this.renderEditor_Label(), this.renderEditor_Description()] });
    };
    // ######################## Render - Editors ########################
    renderEditor_Label = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__value', children: editable.item.label }) },
                    { key: viewMode_Edit, renderer: () => _jsx(DefaultEditor_InputText, { editable: editable, prop: 'label' }) }
                ] }) });
    };
    renderEditor_Description = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Description', children: _jsx(DefaultEditor_TextArea, { disabled: this.getViewMode() !== viewMode_Edit, resizeWithText: true, editable: editable, prop: 'description' }) });
    };
}
//# sourceMappingURL=Editor_FlowSheet.js.map